import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AntEnvService{
    private readonly CONFIG_URL = 'assets/contando.json?t=' + new Date().getTime();
    private readonly CONFIG_URL_STORES = 'assets/stores.json?t=' + new Date().getTime();
    private antEnv$: Observable<AntEnv>;
    private antEnv1$: Observable<AntEnv>;

    constructor(private http: HttpClient) {}

    public load(): any {
        if (!this.antEnv$) {
          this.antEnv$ = this.http.get<AntEnv>(this.CONFIG_URL).pipe(
            shareReplay(1)
          );
        }
        return this.antEnv$;
    }
    public loadToggleStores(): any {
      if(!this.antEnv1$){
        this.antEnv1$ = this.http.get<AntEnv>(this.CONFIG_URL_STORES).pipe(
          shareReplay(1)
        );
      }
      return this.antEnv1$;
    }
}

interface AntEnv{
    apiUrl:string;
    client:string;
};
